import { render, staticRenderFns } from "./policy-mgm.vue?vue&type=template&id=0463ec3e&scoped=true&"
import script from "./policy-mgm.vue?vue&type=script&lang=js&"
export * from "./policy-mgm.vue?vue&type=script&lang=js&"
import style0 from "./policy-mgm.vue?vue&type=style&index=0&id=0463ec3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463ec3e",
  null
  
)

export default component.exports